var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_16927)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.20508 5.61233L5.14024 3.25848H19.7827L20.7179 5.61233H4.20508Z",
    fill: "#328CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9488 2.46156C19.7272 2.46156 20.3877 2.97848 20.6236 3.70463L23.077 11.0769V20.9231C23.077 21.6 22.5462 22.1539 21.8975 22.1539H20.718C20.0693 22.1539 19.5385 21.6 19.5385 20.9231V19.6923H5.38465V20.9231C5.38465 21.6 4.85388 22.1539 4.20517 22.1539H3.02568C2.37696 22.1539 1.84619 21.6 1.84619 20.9231V11.0769L4.29953 3.70463C4.54722 2.97848 5.19594 2.46156 5.9744 2.46156H8.92311C8.92311 1.61189 9.61191 0.923096 10.4616 0.923096H14.4616C15.3112 0.923096 16 1.61189 16 2.46156H18.9488ZM4.20517 14.1539C4.20517 15.1754 4.99542 16 5.9744 16C6.95337 16 7.74363 15.1754 7.74363 14.1539C7.74363 13.1323 6.95337 12.3077 5.9744 12.3077C4.99542 12.3077 4.20517 13.1323 4.20517 14.1539ZM18.9488 16C17.9698 16 17.1795 15.1754 17.1795 14.1539C17.1795 13.1323 17.9698 12.3077 18.9488 12.3077C19.9277 12.3077 20.718 13.1323 20.718 14.1539C20.718 15.1754 19.9277 16 18.9488 16ZM5.9744 4.30771L4.20517 9.84617H20.718L18.9488 4.30771H5.9744Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_16927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxi);
export default __webpack_public_path__ + "static/media/Taxi.f07ebbadf0e684869f4843f98bc8ec9e.svg";
export { ForwardRef as ReactComponent };